import { createContext, useContext } from 'react'
import { useMetas } from '../hooks/useMetas'

const MetasContext = createContext(null)

export function MetasProvider({ children }) {
  return <MetasContext.Provider value={useMetas()}>{children}</MetasContext.Provider>
}

export function useMetasContext() {
  return useContext(MetasContext)
}
